"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getModelsService(
        $baths: Float!
        $beds: Float!
        $distance: Float!
        $hasIfp: Boolean
        $hasVirtualTour: Boolean
        $isMultiSection: Boolean
        $itemsPerPage: String
        $latitude: Float!
        $longitude: Float!
        $maxPrice: Float!
        $maxSquareFeet: Float!
        $minPrice: Float!
        $minSquareFeet: Float!
        $numberOfItemsPerPage: Float
        $pageNumber: String
        $sortMethodId: Float
        $startingIndex: Float
        $features: String
    ) {
        models(
            baths: $baths
            beds: $beds
            distance: $distance
            hasIfp: $hasIfp
            hasVirtualTour: $hasVirtualTour
            isMultiSection: $isMultiSection
            itemsPerPage: $itemsPerPage
            latitude: $latitude
            longitude: $longitude
            maxPrice: $maxPrice
            maxSquareFeet: $maxSquareFeet
            minPrice: $minPrice
            minSquareFeet: $minSquareFeet
            numberOfItemsPerPage: $numberOfItemsPerPage
            pageNumber: $pageNumber
            sortMethodId: $sortMethodId
            startingIndex: $startingIndex
            features: $features
        ) {
            models {
                thumbnailImages {
                    reference
                    imageType
                    imageTypeAcronym
                }
                hasIfp
                hasVirtualTour
                isInStockInArea
                startingInThePrice
                tags
                modelId
                modelNumber
                drawingId
                floorPlanId
                modelDescription
                modelWidth
                modelLength
                minSquareFeet
                maxSquareFeet
                squareFeet
                beds
                baths
                wholesalePrice
                minGeneratedPrice
                maxGeneratedPrice
                lowHistoricalPrice
                highHistoricalPrice
                lowPrice
                highPrice
                twoYearSalesCount
                isMultiSection
                isModular
                isBuildable
                isWebEnabled
                isDealerEntered
                lineId
                creationDate
                lastModificationDate
                hasQualityPhotos
                hasVideo
                hasPhotoRealRendering
                hasIFP
                hasMatterPort
                hasDreamHomeDesign
                thumbnailReference
                has360VirtualTour
                hasProperMediaForPublication
                thumbnailImage
                logoReference
                startingInThePrices
                isMhAdvantageHome
                isPremierFinancingEligible
            }
        }
    }
`;exports.getModels=e;
//# sourceMappingURL=queries.js.map
